import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import AddedFavouriteIcon from "@/assets/images/icons/favourite_ok.svg?inline";
import CloseIcon from "@/assets/images/icons/close.svg?inline";
import MapIcon from "@/assets/images/icons/map.svg?inline";
import WalkScoreIcon from "@/assets/images/pictures/walk_score.svg?inline";
import TransitScoreIcon from "@/assets/images/pictures/transit_score.svg?inline";
import BikeScoreIcon from "@/assets/images/pictures/bike_score.svg?inline";
import btnIconSkip from "@/assets/images/icons/skip.svg?inline";
import ViewsIcons from "@/assets/images/icons/views.svg?inline";
import InterestedIcons from "@/assets/images/icons/interested.svg?inline";
import EditIcon from "@/assets/images/icons/edit.svg?inline";
import ReportIcon from "@/assets/images/icons/report.svg?inline";
import CheckMark from "@/assets/images/icons/check-inverse.svg?inline";

import InterestingBtn from "../../components/InterestingBtn";

import Gallary from "./components/Gallary";
import ShareDropdown from "./components/ShareDropdown";
import PropertyHeadPrerview from "./components/PropertyHeadPrerview";
import EditModal from "./components/EditModal";
import ClaimedHomeLanding from "./components/ClaimedHomeLanding";

import PropertiesCarusel from "@/components/PropertiesCarusel";

import {mapGetters} from "vuex";

import {ADD_TO_INTERESTING, MARKET_INFO, PROPERTY, SIMILAR_PROPERTIES} from "./gql/PropertyQueries";

export default {
  name: "property",

  metaInfo() {
    return {
      title: this.title,
      meta: this.meta
    }
  },

  data() {
    return {
      property: {},
      skipPropertyQuery: true,
      isShowGallary: false,

      title: '',
      meta: [],

      mapZoom: 17,
      gmapOptions: {
        maxZoom: "",
        streetViewControl: false,
        mapTypeControl: false,
        scaleControl: false,
        rotateControl: false,
        zoomControl: false,

        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }]
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }]
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }]
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }]
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }]
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }]
          }
        ]
      },

      circleOptions: {
        fillColor: "rgba(240, 115, 0)",
        fillOpacity: 0.5,
        strokeWeight: 0
      },

      similarProperties: [],
      skipPropertySimilar: true,
      typeSchools: "all",
      schoolLength: 3,
      searchParams: {
        filters: []
      },
      isShowAllMissingFeatures: false,
      isShowAllMatchingFeatures: false,
      isPropertyInformation: false,
      isPropertyOverview: false,
      isNeedOverviewHide: false,
      propertyMainScrolled: false,
      mobileWindow: window.matchMedia("(max-width: 768px)"),
      marketInfo: {},

      phone: "630-597-4877",

      publicView: true,
      skipMetrics: true,
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  apollo: {
    property: {
      query: PROPERTY,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },

      skip() {
        return this.skipPropertyQuery;
      },

      result({ data }) {
        if (!data.property)
          return this.$router.push({ name: "sign_in", replace: true });

        if (!data.property.mainInfo.onMarket) {
          this.gmapOptions.maxZoom = 15;
          this.mapZoom = 15;
        }

        this.skipPropertySimilar = false;
        this.skipMetrics = !data.property.mainInfo.canEdit;

        this.setSiteData(data.property);
      }
    },

    similarProperties: {
      query: SIMILAR_PROPERTIES,
      variables() {
        return {
          propertyId: Number(this.$route.params.id)
          // limit: 10
        };
      },

      skip() {
        return this.skipPropertySimilar;
      },

      result() {
        this.skipPropertySimilar = true;
        this.matchLocationHeight();
      }
    },

    marketInfo: {
      query: MARKET_INFO,
      variables() {
        return {
          propertyId: Number(this.$route.params.id)
        };
      },

      skip() {
        return this.skipMetrics;
      },

      result() {}
    }
  },

  props: [],

  mounted: function() {
    if (this.mobileWindow.matches) {
      window.removeEventListener("scroll", this.handleScroll);
      this.propertyMainScrolled = true;
    }

    this.skipPropertyQuery = false;

    window.Intercom("update", {
      hide_default_launcher: true
    });
  },

  beforeRouteEnter(to , from, next){
    next(vm => vm.setData(to.query));
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    locationPosition() {
      if (this.property && this.property.mainInfo) {
        return {
          lat: this.property.mainInfo.coordinates[0],
          lng: this.property.mainInfo.coordinates[1]
        };
      } else {
        return {
          lat: 41.8336479,
          lng: -87.642012
        };
      }
    },

    isOnMarket() {
      return this.property.mainInfo.onMarket;
    },

    statusMarket() {
      return this.property.mainInfo.onMarket ? "On-Market" : "Off-Market";
    },

    sortedSchools() {
      if (this.typeSchools == "all") {
        return this.property.schools;
      } else {
        return this.property.schools.filter(
          s => s.schoolLevel.toLowerCase() == this.typeSchools
        );
      }
    },

    paginatedSchools() {
      return this.sortedSchools.slice(0, this.getSchoolLength);
    },

    getSchoolLength() {
      if (this.mobileWindow.matches) {
        return this.schoolLength - 1;
      } else {
        return this.schoolLength;
      }
    },

    likelyLevel() {
      let level = "";

      if (this.property.likelihoodToSell == null) {
        return "";
      }

      switch (this.property.mainInfo.likelihoodToSell) {
        case "Likely":
          level = "🔥";
          break;

        case "Very Likely":
          level = "🔥🔥";
          break;

        case "Super Likely":
          level = "🔥🔥🔥";
          break;

        default:
          level = "🔥";
          break;
      }

      return `Chance to Sell: ${this.property.mainInfo.likelihoodToSell} ${level}`;
    },

    markerIcon() {
      return {
        // url: require("@/assets/images/icons/analytics_marker-onMarket.svg")
        url: require(`@/assets/images/icons/analytics_marker-${
          this.property.mainInfo.onMarket ? "onMarket" : "offMarket"
        }.svg`),
        anchor: this.property.mainInfo.onMarket ? null : { x: 16, y: 20 }
      };
    },

    isMobile() {
      return this.$mq === "sm" || this.$mq === "xs";
    },

    hideStickyBlock() {
      if (this.isMobile && this.currentUser.role == "agent") {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    setData(params) {
      if (!params || !params.public)
          return;

      this.publicView = params.public !== 'true';
    },

    goToPublicView() {
      let routeData = this.$router.resolve({name: 'property', query: {public: true}});
      window.open(routeData.href, '_blank');
    },

    setSiteData(property) {
      if (property.mainInfo.onMarket) {
        this.setTitle(property);
        this.setMeta(property)
      } else {
        this.setTitleOffMarket(property);
        this.setMetaOffMarket(property);
      }

      this.$meta().refresh();
    },

    setTitleOffMarket(property) {
      if (!property || !property.mainInfo)
        return;

      this.title = `Open listing ${property.mainInfo.city} home is ${property.mainInfo.likelihoodToSell} to go on sale | AnyCurb`;
    },

    isOffMarketClaimed() {
      return this.property.mainInfo.status === 'Off-Market Claimed';
    },

    setMetaOffMarket(property) {
      let school = property.schools.filter(school => school.schoolLevel === 'High')[0];
      if (school)
        school = school.title;
      let description = `This off-market property in ${property.mainInfo.city} is ${property.mainInfo.likelihoodToSell} to go on sale in the ${school} District. ${property.mainInfo.insights}.`;

      return this.meta = [
        {
          name: 'description',
          content: description,
          vmid: 'description',
        },
        {
          property: 'og:title',
          content: this.title,
          vmid: 'og:title',
        },
        {
          property: 'og:url',
          content: `${window.location}`,
          vmid: 'og:url',
        },
        {
          property: 'og:description',
          content: description,
          vmid: 'og:description'
        },
      ];
    },

    setMeta(property) {
      let image;
      let school = property.schools.filter(school => school.schoolLevel === 'High')[0];
      if (school)
        school = school.title;

      if (property.photos.length)
        image = property.photos[0].preview2x;

      let description = `Offered at $${property.mainInfo.listPrice}, this ${property.mainInfo.bedrooms} Bedroom, ${property.mainInfo.bathsFull} Bathroom home is located in the ${school} School District of ${property.mainInfo.city}. ${property.mainInfo.overview}`

      return this.meta = [
        {
          name: 'description',
          content: description,
          vmid: 'description',
        },
        {
          property: 'og:title',
          content: this.title,
          vmid: 'og:title',
        },
        {
          property: 'og:url',
          content: `${window.location}`,
          vmid: 'og:url',
        },
        {
          property: 'og:description',
          content: description,
          vmid: 'og:description',
        },
        image ? {
            property: 'og:image',
            content: image,
            vmid: 'og:image'
          } : null
      ];
    },

    setTitle(property) {
      if (!property || !property.mainInfo)
        return;

      this.title = `${property.mainInfo.bedrooms} bedroom home for sale in ${property.mainInfo.city} | ${property.mainInfo.fullAddress} | AnyCurb`;
    },

    changeTypeSchools(type) {
      this.schoolLength = 3;
      this.typeSchools = type;
    },

    handleHihglightProperty(type) {
      let iconDefault = {
        url: require("@/assets/images/icons/marker.png")
      };
      let iconHover = {
        url: require("@/assets/images/icons/marker_active.png")
      };

      this.markerIcon = type ? iconHover : iconDefault;
    },

    addSchools() {
      this.schoolLength = this.schoolLength + 10;
    },

    ratingColor(amount) {
      switch (amount) {
        case amount > 0 && amount <= 2:
          return "rating__worst";

        case amount > 2 && amount <= 4:
          return "rating__medium";

        case amount > 4:
          return "rating__good";

        default:
          return "";
      }
    },

    matchLocationHeight() {
      let overviewHeight;

      if (this.mobileWindow) {
        overviewHeight = 56;
        // 56 - height of property overview text
      } else {
        overviewHeight = this.$refs.mapBox.clientHeight - 64;
      }

      this.isNeedOverviewHide = this.$refs.infoBox
        ? this.$refs.infoBox.clientHeight > overviewHeight
        : false;
    },

    handleScroll() {
      let headerHeight =
        this.$refs.headBox.clientHeight +
        this.$refs.propertyMainBox.clientHeight +
        67;
      this.propertyMainScrolled = window.scrollY > headerHeight;
    },

    handleShowGallary(event) {
      this.isShowGallary = event;
    },

    handleUpdatePropertyInteresting(interesting) {
      this.property.mainInfo.isInteresting = interesting;
      this.property.mainInfo.interestingPropertiesCount = interesting
        ? this.property.mainInfo.interestingPropertiesCount + 1
        : this.property.mainInfo.interestingPropertiesCount - 1;
    },

    openEditModal() {
      this.$refs.editModalComponent.showModal();
    },

    addToInterested() {
      this.$apollo
        .mutate({
          mutation: ADD_TO_INTERESTING,
          variables: {
            propertyId: this.property.mainInfo.id
          }
        })
        .then(({ data }) => {
          let message = "";
          let href = this.$router.resolve({
            name: "public_user_profile",
            params: { id: this.currentUser.id }
          }).href;

          // ADD TO INTERESTING
          if (data.createInterestingProperty.status == 200) {
            message = `<div>Added to your interested homes. View interested homes&nbsp;<a href="${href}">here</a>.<div>`;
          }

          let toast = this.$toasted.success(message);

          toast.el.getElementsByTagName("a")[0].addEventListener("click", e => {
            e.preventDefault();

            this.$router.push({
              name: "public_user_profile",
              params: { id: this.currentUser.id }
            });

            this.$toasted.clear();
          });

          this.property.mainInfo.isInteresting = true;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          window.location.href = `tel://${this.phone}`;
        });
    }
  },

  watch: {
    $route() {
      this.isShowGallary = false;
      this.property = [];

      this.typeSchools = "all";
      this.schoolLength = 3;
      this.isShowAllMissingFeatures = false;
      this.isShowAllMatchingFeatures = false;
      this.isPropertyInformation = false;
      this.isPropertyOverview = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    window.Intercom("update", {
      hide_default_launcher: false
    });
    next();
  },

  components: {
    LoadingIcon,
    AddedFavouriteIcon,
    CloseIcon,
    Gallary,
    ShareDropdown,
    MapIcon,
    CheckMark,
    WalkScoreIcon,
    TransitScoreIcon,
    BikeScoreIcon,
    PropertiesCarusel,
    btnIconSkip,
    PropertyHeadPrerview,
    ViewsIcons,
    InterestedIcons,
    InterestingBtn,
    EditIcon,
    ReportIcon,
    EditModal,
    ClaimedHomeLanding,
  }
};
